"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Body2", {
    enumerable: true,
    get: function() {
        return Body2;
    }
});
const _createPreset = require("../createPreset");
const _useBody2Stylesstyles = require("./useBody2Styles.styles");
const Body2 = (0, _createPreset.createPreset)({
    useStyles: _useBody2Stylesstyles.useBody2Styles,
    className: _useBody2Stylesstyles.body2ClassNames.root,
    displayName: 'Body2'
});
